module.exports = __webpack_public_path__ + "static/media/multiple-choice-columns-cloud-2.7ec097df.svg";